import { GQLInteractionContactType } from 'src/generated/graph-api';
import type { OfferPackage, OfferPackageContact } from './types';

type DocumentPdfTitles = Record<string, string>;

export const DOCUMENT_TITLES: DocumentPdfTitles = {
  coverLetterShortUrl: 'Cover Letter',
  disclosuresShortUrl: 'Disclosures',
  offerDocsShortUrl: 'Offer Docs',
  preQualShortUrl: 'Pre Qual',
  proofOfFundsShortUrl: 'Proof of Funds',
};

const findFirstContactWithRole = (
  role: GQLInteractionContactType,
  contacts: (OfferPackageContact | null)[],
) => {
  return contacts.find((contact) => contact?.type === role);
};

export const composeEmail = (
  contacts: (OfferPackageContact | null)[],
  combined: boolean,
  offerPackage: Partial<OfferPackage>,
  propertyStreet: string,
) => {
  const agent = findFirstContactWithRole(
    GQLInteractionContactType.agent,
    contacts,
  );
  const counterPartyAgent = findFirstContactWithRole(
    GQLInteractionContactType.counterpartyAgent,
    contacts,
  );

  const linkSectionText = combined
    ? 'Please see the following link containing our complete offer package'
    : 'Please see the below for details on our offer package';

  const packageUrls = combined
    ? offerPackage.combinedShortUrl?.url
    : Object.entries(offerPackage || {})
        .map(([section, sectionObj]) =>
          DOCUMENT_TITLES[section] &&
          sectionObj &&
          typeof sectionObj === 'object' &&
          sectionObj.url &&
          sectionObj.id
            ? `${DOCUMENT_TITLES[section]}: ${sectionObj.url}`
            : undefined,
        )
        .filter((listItems) => typeof listItems !== 'undefined')
        .join('\n\n');

  const body = encodeURIComponent(
    `Dear ${counterPartyAgent?.firstName ?? ''} ${
      counterPartyAgent?.lastName ?? ''
    },\n\n` +
      `I am very excited to present my client’s excellent offer for ${propertyStreet}. ${linkSectionText}:\n\n` +
      `${packageUrls}\n\nPlease don’t hesitate to reach out to me with ` +
      'any questions. I look forward to the opportunity to work with you on a ' +
      `smooth closing.\n\nWarmest Regards,\n${agent?.firstName ?? ''} ${
        agent?.lastName ?? ''
      }`,
  );

  return `mailto:${
    counterPartyAgent?.email ?? ''
  }?body=${body}&subject=Offer Packet for ${propertyStreet}`;
};
